import axios from 'axios'
import { isProdEnv, OPTIBASE_PUBLIC_API_KEY } from 'shared/config'

// Fires an Optibase conversion event attributed to the experiment variant the visitor saw on www.salesmessage.com.
// Reads sm_optibase_uid set by the Webflow site when Optibase loads for non-customer visitors.
// Fails silently if the cookie is absent or the request fails — never blocks the calling flow.
export const trackOptibaseConversion = async (conversionId: string): Promise<void> => {
  const match = document.cookie.match(/(^| )sm_optibase_uid=([^;]+)/)
  if (!match) return

  if (!isProdEnv) {
    console.log('[Optibase] Conversion would fire with:', {
      publicApiKey: OPTIBASE_PUBLIC_API_KEY,
      userFriendlyConversionId: conversionId,
      testedUserId: match[2],
    })
    return
  }

  try {
    await axios.post('https://app.optibase.io/api/script/conversionEvent', {
      publicApiKey: OPTIBASE_PUBLIC_API_KEY,
      userFriendlyConversionId: conversionId,
      testedUserId: match[2],
    })
  } catch {
    // never block or affect the calling flow
  }
}
